import { render } from "./upload.vue?vue&type=template&id=63efde38"
import script from "./upload.vue?vue&type=script&lang=ts"
export * from "./upload.vue?vue&type=script&lang=ts"
script.render = render

export default script